<p>🏷️ Prețurile unora dintre produse variază în funcție de grosime și finisaj, ce este afișat sunt prețurile de pornire.</p>
<p>📞 Pentru comenzi online puteți accesa linkul <a routerLink="../calcul/manual"> acesta</a> sau la <a  (click)="trackConversion('Pv7pCN3In6QZELWMoq4q')" href="tel:0740101510">0740 101 510</a> /
  <a href="mailto:vanzari@experttabla.ro">vanzari@experttabla.ro</a></p>
<div id="wrapper">

  <div>
    <h2>Prețuri tablă</h2>
    <price-table [products]="tilesEvent"></price-table>
  </div>

  <div>
    <h2>Prețuri accesorii</h2>
    <price-table [products]="accessoriesEvent"></price-table>
  </div>
  <div>
    <h2>Prețuri sistem pluvial</h2>
    <price-table [products]="rainSystemEvent"></price-table>
  </div>
</div>
